import $ from "jquery";
import { Component, ComponentDefinition } from "../../components/Component";
import { isPostRenderedComponent } from "../../components/Component";
import { ComponentFactory } from "./../../../components/componentFactory";

export class FullPage implements Component {
    public componentType = "fullPage";
    public view: JQuery;
    public definition: FullPageDefinition;
    public id: string;
    private children: Component[] = [];

    constructor(schema: FullPageDefinition) {
        this.definition = schema;
    }

    public render(): Element {
        document.title = this.definition.pageTitle;
        this.view = $('<div class="c-full-page" id="' + this.definition.id + '"></div>');
        return this.view[0];
    }

    public appendChildView = (childView: Node): void => {
        $(childView).appendTo(this.view);
    }

    public postRender() {
        $.each(this.children, (key, component) => {
            if (isPostRenderedComponent(component)) {
                component.postRender();
            }
        });
    }

    public getView() {
        return this.view;
    }
}

export interface FullPageDefinition extends ComponentDefinition {
    pageTitle?: string;
}
